import React from 'react';
import { PropTypes } from 'prop-types';
import { history } from 'containers/App';

import ErrorPage from 'components/Errors/ErrorPage';

const ServerError = ({ code, message }) => <ErrorPage title="Server Error" type="server" showButton onButtonClick={ () => history.go(-1) }>
  <p>{ message != null ? message : 'Unfortunately the operation was not completed.' }</p>
  <p className="cp-primary"><b>{ code != null ? code : 500 }</b></p>
  <p>Please reload and try again.</p>
  <p>If the problem persists please contact our helpdesk.</p>
</ErrorPage>;

ServerError.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
};

ServerError.defaultProps = {
  code: 500,
  message: 'Unfortunately the operation was not completed.'
};

export default ServerError;
